import { render, staticRenderFns } from "./CompareSchool.vue?vue&type=template&id=4a86a802&scoped=true"
import script from "./CompareSchool.vue?vue&type=script&lang=js"
export * from "./CompareSchool.vue?vue&type=script&lang=js"
import style0 from "./CompareSchool.vue?vue&type=style&index=0&id=4a86a802&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a86a802",
  null
  
)

export default component.exports